import { render, staticRenderFns } from "./ReporteNovedadesHSETabla.vue?vue&type=template&id=8bf5fe82"
import script from "./ReporteNovedadesHSETabla.vue?vue&type=script&lang=js"
export * from "./ReporteNovedadesHSETabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports